import { useState } from "react";
import style from "./HamburgerMenu.module.css";

function HamburgerMenu({ onClick }) {
  const [hamburger, setHamburger] = useState(false);

  return (
    <button
      className={
        "d-block d-lg-none " +
        style.hamburger +
        (hamburger ? " " + style.isActive : "")
      }
      onClick={() => {
        onClick();
        setHamburger(cur => !cur);
      }}
    >
      <div className={style.bar}></div>
    </button>
  );
}

export default HamburgerMenu;
